import React from 'react';
import PropTypes from 'prop-types';

import { IconButton, Box } from '@metarouter-private/mr-mui';

import WithTooltip from 'app/components/WithTooltip';

const ICON_TOOLTIP_BOX_PROPS = {
  display: 'flex',
  alignItems: 'center',
};

/**
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {boolean} props.disabled - Maps to IconButton
 * @param {string} props.tooltipMessage - Required tooltip message
 * @param {string} props.ariaLabel - Optional accessible name; the tooltip sits on a wrapper, not the button
 * @param {string} props.dataTestId - Optional test ID
 * @param {Function} props.onClick - Optional click handler
 *
 * @returns {React.ReactNode}
 */
export default function ActionIconButton({
  children,
  disabled = false,
  tooltipMessage,
  ariaLabel,
  dataTestId,
  onClick,
}) {
  const tooltipProps = {
    Container: Box,
    ContainerProps: ICON_TOOLTIP_BOX_PROPS,
    show: true,
    title: tooltipMessage,
  };

  const iconButtonProps = {
    ...(dataTestId ? { 'data-test-id': dataTestId } : {}),
    ...(ariaLabel ? { 'aria-label': ariaLabel } : {}),
    ...(onClick ? { onClick } : {}),
    disabled,
  };

  return (
    <WithTooltip {...tooltipProps}>
      <IconButton {...iconButtonProps}>{children}</IconButton>
    </WithTooltip>
  );
}

ActionIconButton.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  tooltipMessage: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  dataTestId: PropTypes.string,
  onClick: PropTypes.func,
};
